import { Table } from "@tanstack/react-table";
import Button from "@weave-design/button";
import Dropdown from "@weave-design/dropdown";
import "./commonTableComponents.css";

export const TablePagination = <TData,>({ table }: { table: Table<TData> }) => (
    <div className="table-pagination">
        <div className="table-pagination__page-index">
            <Button
                title="Previous"
                type="secondary"
                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}
            />
            <Button title="Next" type="secondary" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()} />
            <span>
                Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
            </span>
        </div>
        <div className="table-pagination__page-size">
            <span>Show</span>
            <Dropdown
                options={[100, 250, 500]}
                value={table.getState().pagination.pageSize}
                onChange={(newValue: string) => table.setPageSize(Number(newValue))}
                variant="box"
            />
        </div>
    </div>
);
